import { formatNumberWithFractionDigits } from '~/helpers/thousandFormatNumber';

import { MaintenanceAnalytics } from '../../helpers/api';
import { StateChartDatum, StatesBarUnit } from './types';

type StateRow = MaintenanceAnalytics['STATES'][number];

export function buildData(
  rows: StateRow[] | undefined,
  unit: StatesBarUnit,
): StateChartDatum[] {
  if (!rows) return [];
  return [...rows]
    .map((row) => ({
      name: row.NAME,
      fullName: row.FULL_NAME,
      value: unit === 'capacity' ? row.COOLING_CAPACITY_TR : row.MACHINES_COUNT,
    }))
    .sort((a, b) => b.value - a.value);
}

export function formatCompact(value: number): string {
  const abs = Math.abs(value);
  if (abs >= 1e9) {
    return `${formatNumberWithFractionDigits(value / 1e9, { minimum: 1, maximum: 1 })}B`;
  }
  if (abs >= 1e6) {
    return `${formatNumberWithFractionDigits(value / 1e6, { minimum: 1, maximum: 1 })}M`;
  }
  if (abs >= 1e3) {
    return `${formatNumberWithFractionDigits(value / 1e3, { minimum: 0, maximum: 0 })}k`;
  }
  return formatNumberWithFractionDigits(value, { minimum: 0, maximum: 0 });
}

export function formatTooltipValue(value: number, unit: StatesBarUnit): string {
  if (unit === 'capacity') {
    return `${formatNumberWithFractionDigits(value, { minimum: 1, maximum: 1 })} TR`;
  }
  return formatNumberWithFractionDigits(value, { minimum: 0, maximum: 0 });
}
